import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  apikey,
  apisecret,
  getFormObj,
  server_domain,
} from "../../services/constants";
import { post } from "../../services/axios";
import { useDispatch, useSelector } from "react-redux";
import { setError } from "../../redux/appsettingSlice";
import { Container } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import VouchedTitle from "./components/VouchedTitle";
import VoucherInfo from "./components/VoucherInfo";
import VoucherDesc from "./components/VoucherDesc";
import ExchangeModal from "./components/ExchangeModal";

const RedeemVoucher = () => {
  const [open, setOpen] = useState(false);
  const [openExchangeModal, setOpenExchangeModal] = useState(false);
  const [data, setData] = useState();
  const [formData, setFormData] = useState({});
  const [token, setToken] = useState();

  const { search } = useLocation();
  const navigate = useNavigate();

  const dateRefs = useRef([]);
  const dateTimeValuesRef = useRef({});
  const { isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleNavigate = () => {
    navigate("/your-order");
  };

  const handleChange = (e, index, type) => {
    const name = `Q_${index}_${type}`;
    setFormData({
      ...formData,
      [name]: e?.target?.value ?? e,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const postData = {
      apikey: apikey,
      apisecret: apisecret,
      api_method: "redeem_voucher",
      voucher_id: token,
      redeem: "1",
      global: JSON.stringify({ ...formData, ...dateTimeValuesRef.current }),
    };

    try {
      const response = await post(`${server_domain}`, postData);

      if (response.status === 200) {
        const isNoRedirect =
          response?.data?.message?.includes("you answer all");
        dispatch(
          setError({
            isShow: true,
            alert_title: response?.data?.alert_title,
            alert_text: response?.data?.message,
            alert_action_button_title: "Close",
            alert_action_url: isNoRedirect ? undefined : "/your-order",
          }),
        );
      }
    } catch (error) {
      submitFailed(error);
    }
  };

  const loadRedeemForm = async (id) => {
    let rdata = getFormObj();
    rdata.append("api_method", "redeem_voucher");
    rdata.append("voucher_id", id);

    try {
      const response = await post(server_domain, rdata);

      if (response.status === 200) {
        const { questions } = response.data;
        const formQuestion = {};

        if (questions) {
          questions?.map((el, idx) => {
            return (formQuestion[`Q_${idx}_question`] = el.question);
          });

          setFormData(formQuestion);
          dateTimeValuesRef.current = {};
        }

        setData(response.data);

        if (response.data.alert_title) {
          const voucherInfo = document.querySelector(".alert");
          voucherInfo?.setHTMLUnsafe(response.data.alert_title);
        }
      } else if (response.data.error) {
        submitError(response);
      }
    } catch (err) {
      submitFailed(err);
    }
  };

  const submitError = (response) => {
    dispatch(
      setError({
        isShow: true,
        alert_title: response?.data?.alert_title ?? "Thanks!",
        alert_text:
          response?.data?.alert_text ??
          `Your voucher ${data?.voucher?.code} has been redeemed... you can proceed to log into your account if you'd like to track your voucher's progress.`,
        alert_action_button_title: "Close",
      }),
    );
  };

  const submitFailed = (err) => {
    dispatch(
      setError({
        isShow: true,
        alert_title: "Error",
        alert_text: "",
        alert_action_button_title: "",
        alert_action_url: "",
        message: err.toString(),
      }),
    );
  };

  useEffect(() => {
    if (search) {
      setToken(search.split("=")[1]);

      loadRedeemForm(search.split("=")[1]);
    }
  }, [search]);

  return (
    <Container>
      <div className="reedem-voucher__wrap">
        {isAuthenticated && (
          <button
            className="reedem-voucher__btn buttony-gold text-dark badge fs-6 py-2"
            children={"Back"}
            onClick={handleNavigate}
          />
        )}
        <div className="reedem-voucher">
          <VouchedTitle data={data} />
          {data?.voucher && (
            <VoucherInfo data={data} id={token} reload={loadRedeemForm} />
          )}
          {data?.voucher && <VoucherDesc data={data} />}
          {data?.questions && (
            <form onSubmit={handleSubmit} className="p-3 position-relative">
              {data?.questions?.map((field, index) => {
                const name = `Q_${index}_${field.type}`;
                const value = formData[name] || "";

                return (
                  <div className="mb-3" key={index}>
                    <label className="form-label">{field.question}</label>

                    {/* {field.type === "text" && (
                      <input
                        type="text"
                        className="form-control"
                        value={value}
                        onChange={(e) => handleChange(e, index, field.type)}
                        required
                      />
                    )} */}

                    {(field.type === "text" || field.type === "textarea") && (
                      <textarea
                        rows={3}
                        className="form-control"
                        value={value}
                        onChange={(e) => handleChange(e, index, field.type)}
                        required
                      />
                    )}

                    {(field.type === "date" || field.type === "date_time") && (
                      <div className="input-group">
                        <span
                          className="input-group-text"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            dateRefs.current[index]?.flatpickr?.open()
                          }
                        >
                          <i className="fas fa-calendar-alt" />
                        </span>
                        <Flatpickr
                          ref={(el) => (dateRefs.current[index] = el)}
                          className="form-control"
                          value={field.type === "date_time" ? undefined : value}
                          defaultValue={
                            field.type === "date_time" ? value : undefined
                          }
                          options={{
                            dateFormat:
                              field.type === "date_time"
                                ? "d-m-Y H:i"
                                : "d-m-Y",
                            enableTime: field.type === "date_time",
                            closeOnSelect: field.type !== "date_time",
                            time_24hr: true,
                          }}
                          onChange={(selectedDates, dateStr) => {
                            if (field.type === "date_time") {
                              dateTimeValuesRef.current[name] = dateStr;
                              return;
                            }

                            const fakeEvent = {
                              target: {
                                value: dateStr,
                              },
                            };
                            handleChange(fakeEvent, index, field.type);
                          }}
                          required={true}
                        />
                      </div>
                    )}

                    {(field.type === "dropdown" || field.type === "select") && (
                      <select
                        className={`form-control custom-select ${
                          open ? "open" : ""
                        }`}
                        value={value}
                        onChange={(e) => {
                          handleChange(e, index, field.type);
                          setOpen(false);
                        }}
                        required
                        onMouseDown={() => setOpen(!open)}
                        onBlur={() => setOpen(false)}
                      >
                        <option disabled value="">
                          Select...
                        </option>
                        {field.options?.split(",").map((opt, idx) => (
                          <option key={idx} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    )}

                    {field.type === "checkboxes" &&
                      field.options?.split(",").map((opt, idx) => {
                        const checkboxName = `Q_${index}_checkboxes`;
                        const isChecked = formData[checkboxName] === opt.trim();

                        return (
                          <div className="form-check" key={idx}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`chk_${index}_${idx}`}
                              checked={isChecked}
                              onChange={() => {
                                const checkboxName = `Q_${index}_${field.type}`;
                                const isChecked =
                                  formData[checkboxName] === opt.trim();

                                if (isChecked) {
                                  handleChange("", index, field.type);
                                } else {
                                  handleChange(opt.trim(), index, field.type);
                                }
                              }}
                            />
                            <label
                              className="form-check-label ms-2"
                              htmlFor={`chk_${index}_${idx}`}
                            >
                              {opt.trim()}
                            </label>
                          </div>
                        );
                      })}
                  </div>
                );
              })}
              {data && (
                <>
                  <button
                    type="submit"
                    className="btn btn-success"
                    children={"Redeem Voucher"}
                  />
                  <div className="position-absolute bottom-0 end-0">
                    <p className="mb-1 text-end" style={{ fontSize: "14px" }}>
                      {data?.exchange_options?.message}
                    </p>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      children={data?.exchange_options?.button}
                      onClick={() => setOpenExchangeModal(true)}
                    />
                  </div>
                </>
              )}
            </form>
          )}
        </div>
      </div>
      {data?.exchange_options && !Array.isArray(data?.exchange_options) && (
        <ExchangeModal
          id={token}
          voucher={data?.voucher?.code}
          show={openExchangeModal}
          close={() => setOpenExchangeModal(false)}
          reload={loadRedeemForm}
          data={{
            data: data?.exchange_options?.terms,
            value: data?.exchange_options?.value,
          }}
        />
      )}
    </Container>
  );
};

export default RedeemVoucher;
